export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEFRXh0LUhhDCEiAb1PAADATAAAwFIFAMBQAADATw8CvVMCBL1WAADAWQAAwFQAAMBXAADAVgARvVtBGCFrwE0ABgASgUAbg3KFQQEAAQABAAEAGQAfAAEAAQAGAIEyAAEAAQABAAEAGQAfAAEAAQAGAGEDJXUBvgKPSQ++BBABvhQ=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/Ext-V.bcmap
// module id = 634
// module chunks = 502